import { useContext, useState } from "react";
import { Snackbar, Alert, AlertTitle } from "@mui/material";
// import Snackbar from "@mui/material/Snackbar";
import nodeContext from "../Context/Notes/NotesContext";

function MyAlert(props) {
  const { alert, setAlert, alertMessage, alertVariant } =
    useContext(nodeContext);
  const closeAfter = () => {
    setTimeout(function () {
      setAlert(false);
    }, 5000);
  };
  closeAfter();
  return (
    <>
      {alert ? (
        <Alert
          variant="filled"
          severity={alertVariant}
          sx={{
            maxWidth: "300px",
            width: "100%",
            position: "fixed",
            marginLeft: "10px",
          }}
        >
          {alertMessage}
        </Alert>
      ) : (
        <span></span>
      )}
    </>
  );
}

export default MyAlert;
